import type { DiscountMapper } from '@domains/billing-settings/priv/CustomerDiscount/api/mappers'
import {
  type CreateDiscountRequest,
  type Discount,
  DiscountTypeDiscriminator,
  type FirstNFreeDiscount as FirstNFreeDiscountSpec,
} from '@mynt/backoffice-api-spec/discounts'
import { type CreateDiscount, DiscountModifier, type Discounts, DiscountType, type FirstNFreeDiscount } from '../../api/api'

type FirstNFreeDiscountDto = Discount & {
  discountType: FirstNFreeDiscountSpec
}

export class FirstNFreeDiscountDtoMapper implements DiscountMapper {
  discountTypeLabel = 'First n free'
  supports(discount: Discount): discount is FirstNFreeDiscountDto {
    return discount?.discountType?.type === DiscountTypeDiscriminator.FIRST_N_FREE_DISCOUNT
  }

  supportsType(discountType: string): boolean {
    return discountType === DiscountTypeDiscriminator.FIRST_N_FREE_DISCOUNT
  }

  supportsCreateDiscount(request: CreateDiscount): request is CreateDiscount<FirstNFreeDiscount> {
    return request.discountType.type === DiscountType.FirstNFreeDiscount
  }

  asDiscounts(discount: Discount): Discounts {
    if (!this.supports(discount)) {
      throw new Error('Unsupported discount type')
    }

    return {
      adornment: '',
      expirationDate: discount.expirationDate ? new Date(discount.expirationDate) : undefined,
      type: DiscountType.FirstNFreeDiscount,
      value: discount.discountType.count,
      modifier: DiscountModifier.ABSOLUTE,
    }
  }

  asCreateDiscountRequest(request: CreateDiscount): CreateDiscountRequest {
    if (!this.supportsCreateDiscount(request)) {
      throw new Error('Unsupported discount type')
    }

    return {
      discountType: {
        type: DiscountTypeDiscriminator.FIRST_N_FREE_DISCOUNT,
        count: request.discountType.numberOfFreeItems,
      },
      expirationDate: request.expirationDate,
    }
  }
}
